import React, { useEffect } from 'react';
import isDOM from 'helpers/isDOM';

import selectLinkedSection from 'helpers/selectLinkedSection';
import cacheHandler from 'helpers/cacheHandler';

export default function RendererComponent(props) {

  const {
    section,
    templateSchema,
    language = 'en',
    pageSlug,
    secondSlug,
    chapterSlug,
    params,
    windowWidth,
    currentPage,
    thisSectionData,
    pages,
    defaultValues,
    agendaData,
    organization
  } = props;

  const {
    presentations,
    navigations,
    streams,
    speakers,
    companies,
    venues,
    forms,
    savedSections,
    organizationId,
    templateId,
    defaultVenue,
    logo,
    tickets,
    subscriptions,
    calendars,
    customStyles,
    faviconImage,
    presentationTags,
    eventTags
  } = templateSchema;

  const thisSectionSelect = selectLinkedSection(savedSections, thisSectionData.sectionIdLinked ? thisSectionData.sectionIdLinked : thisSectionData.sectionId, thisSectionData);
  const getSectionData = thisSectionSelect.section ? thisSectionSelect.section : thisSectionSelect;

  const ThisComponent = cacheHandler('get', 'injectCache', `components/Templates/components/${getSectionData.type.toLowerCase()}/${getSectionData.componentName}/index.js`);

  if (!ThisComponent || !ThisComponent.default) return;



  if (getSectionData && (getSectionData.type === 'agenda' || getSectionData.type === 'agendaStacked')) getSectionData.availableTags = presentationTags;
  if (getSectionData && getSectionData.type === 'calendar') getSectionData.availableTags = eventTags;

  const setStyling = cacheHandler('get', 'injectCache', section.sectionIdLinked ? section.sectionIdLinked : section.sectionId);

  const commonProps = {
    language: language,
    styling: setStyling,
    pages: pages,
    timezone: templateSchema.timezone,
    baseUrlTamplate: pageSlug === 'location' && secondSlug ? '/location/'+secondSlug : chapterSlug ? '/location/'+chapterSlug : '',
    logo: logo,
    params: params,
    savedSections: savedSections,
    windowWidth: windowWidth,
    faviconImage: faviconImage,
    viewRef: '#PublicViewEventWrapper-id',
  };

  const commonData = {
    componentPayload: getSectionData,
    styling:  setStyling,
    pageIdLinked: section.pageIdLinked,
    sectionIdLinked: section.sectionIdLinked,
    sectionId: section.sectionId,
    organizationId: organizationId,
    templateId: templateId,
    pageId: currentPage.pageId,
    customStyles: customStyles,
    renderSync: getSectionData.type === 'navigation',
    organizationSlug: organization.slug,
    templateSlug: templateSchema.slug
  };



  const {
    type
  } = thisSectionSelect;





  useEffect(() => {
    // if not a hash link, scroll to top
    const elementId = commonData?.componentPayload.hashId || commonData?.componentPayload.sectionId;

    if (isDOM && window.location.hash.replace('#', '') === elementId) {
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView();
        }
      }, 60);
    }
  }, []);


  return (
    <ThisComponent.default
      commonProps={commonProps}
      commonData={commonData}
      agendaData={type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'agendaStacked' || type === 'speaker' ? agendaData : null}
      presentations={type === 'speaker' ? presentations : null}
      tickets={type === 'tickets' ? getSectionData.tickets : null}
      ticketsData={type === 'tickets' || type === 'workshop' ? tickets : null}
      presentationsData={type === 'workshop' ? presentations : null}
      subscriptions={type === 'subscriptions' ? getSectionData.subscriptions : null}
      subscriptionsData={type === 'subscriptions' ? subscriptions : null}
      navigationId={type === 'navigation' ? getSectionData.navigationId : null}
      navigations={type === 'navigation' ? navigations : null}
      speakers={type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'speaker' || type === 'workshop'|| type === 'agendaStacked' ? speakers : null}
      companies={type === 'partners' || type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda'|| type === 'agendaStacked' ? companies : null}
      forms={type === 'form' ? forms : null}
      calendars={type === 'calendar' ? calendars : null}
      streams={type === 'stream' ? streams : null}
      venues={type === 'venue' ? venues : null}
      defaultVenue={type === 'venue' ? defaultVenue : null}
      defaultValues={defaultValues}
      viewRef={'#PublicViewEventWrapper-id'}
    />
  );

}
